import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ICalendarTasksState {
    wasChangedTask: boolean;
    externalTableTaskPrefixFetchKey?: string;
}

const initialState: ICalendarTasksState = {
    wasChangedTask: false,
    externalTableTaskPrefixFetchKey: '',
};

export const calendarTasksSlice = createSlice({
    name: 'calendarTasks',
    initialState,
    reducers: {
        setterCalendarTasks: (state, action: PayloadAction<Partial<ICalendarTasksState>>) => {
            if (!Object.keys(action.payload).length) {
                return state;
            }

            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { setterCalendarTasks } = calendarTasksSlice.actions;

export default calendarTasksSlice.reducer;
